import type { LmsLaunchErrorPresentation } from '../../../utils/lmsLaunchErrors';

export const LMS_EMBED_ORIGIN_DENIED = 'LMS_EMBED_ORIGIN_DENIED';
export const LMS_EMBED_TIMEOUT = 'LMS_EMBED_TIMEOUT';
export const LMS_EMBED_DISABLED = 'LMS_EMBED_DISABLED';
export const LMS_EMBED_MALFORMED_MESSAGE = 'LMS_EMBED_MALFORMED_MESSAGE';
export const LMS_EMBED_MISSING_ASSERTION = 'LMS_EMBED_MISSING_ASSERTION';

export function getEmbedErrorPresentation(code: string): LmsLaunchErrorPresentation {
  switch (code) {
    case LMS_EMBED_ORIGIN_DENIED:
      return {
        code,
        title: 'Embed not allowed',
        message:
          'This page cannot receive a sign-in token from the parent window (origin not allowed). Contact your school administrator.',
        canRetry: false,
      };
    case LMS_EMBED_TIMEOUT:
      return {
        code,
        title: 'Waiting for sign-in',
        message:
          'No launch token was received from your learning portal in time. Return to BanyanPro and open Tamil Katral Maiyam again.',
        canRetry: true,
      };
    case LMS_EMBED_DISABLED:
      return {
        code,
        title: 'Embed mode disabled',
        message: 'Iframe embed is not enabled in this environment. Use the standard portal launch link instead.',
        canRetry: false,
      };
    case LMS_EMBED_MALFORMED_MESSAGE:
      return {
        code,
        title: 'Invalid launch message',
        message: 'The parent window sent a message that could not be understood. Please try again from BanyanPro.',
        canRetry: true,
      };
    case LMS_EMBED_MISSING_ASSERTION:
      return {
        code,
        title: 'Missing launch token',
        message: 'No sign-in token was provided by the parent window. Open Tamil Katral Maiyam from BanyanPro again.',
        canRetry: true,
      };
    default:
      return {
        code,
        title: 'Launch failed',
        message: 'An unexpected embed error occurred.',
        canRetry: true,
      };
  }
}
